import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer-section">
        <h2 className="footer-section__content">
          © 2023 by Anton & Lily. Proudly created with Wix.com
        </h2>
      </footer>
    );
  }
}
